<template>
  <div>
    <nav class="navbar navbar-expand-lg sticky-top" id="mainNav">
      <div class="container">
        <a class="navbar-brand" href="/">
          <img :src="'/img/logo.png'" alt="..." />
          <div class="text-brand">
            <span>KolaborAksi</span><br />
            <span>Bangun Negeri</span>
          </div>
        </a>
        <button
          id="navbar-btn"
          class="d-none navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarResponsive"
          aria-controls="navbarResponsive"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i class="fas fa-bars ms-1"></i>
        </button>
        <div class="collapse navbar-collapse" id="navbarResponsive">
          <ul class="navbar-nav text-uppercase ms-auto main-nav">
            <li class="nav-item">
              <a class="nav-link" href="/">Beranda</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/#tentang">Tentang Masjed</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :href="link.program">Program</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/produk">Produk</a>
            </li>
            <!-- <li class="nav-item">
              <a class="nav-link" href="/covid">Covid19</a>
            </li> -->
            <li class="nav-item">
              <a class="nav-link" href="/berita">Berita</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :href="link.carimasjid">Cari MasjedMu</a>
            </li>
          </ul>
          <ul class="navbar-nav custom-nav">
            <li class="custom-item">
              <a href="https://masjed.id/app/site/register" class="btn btn-sm btn-main mr-16">Daftar</a>
              <a href="https://masjed.id/app/site/login" class="btn btn-sm btn-outline">Masuk</a>
            </li>
          </ul>
          <div class="d-md-none footer-links-top">
            <div>
              <div class="footer-title mobile">masjed.id</div>
              <ul>
                <li>
                  <a href="/tentang-kami">Tentang Kami</a>
                </li>
                <li>
                  <a href="/berita">Berita</a>
                </li>
                <li>
                  <a href="https://masjed.id/app/site/index">Program</a>
                </li>
                <li>
                  <a href="/produk">Produk</a>
                </li>
              </ul>
            </div>
            <div>
              <div class="footer-title mobile">Bantuan</div>
              <ul>
                <li>
                  <a href="/syarat-dan-ketentuan">Syarat & Ketentuan</a>
                </li>
                <li>
                  <a href="/faq">F.A.Q</a>
                </li>
                <li>
                  <a href="/hubungi-kami">Hubungi Kami</a>
                </li>
              </ul>
            </div>
            <div>
              <div class="footer-title mobile">Ikuti Kami</div>
              <div class="footer-sosmed">
                <a href="https://www.facebook.com/appsmasjedid" class="facebook" target="_blank" title="Facebook">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-facebook"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"
                    />
                  </svg>
                </a>
                <a href="https://twitter.com/appsmasjedid" target="_blank" title="Twitter">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-twitter"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z"
                    />
                  </svg>
                </a>
                <a href="https://www.instagram.com/masjed.id/" target="_blank" title="Instagram">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-instagram"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"
                    />
                  </svg>
                </a>
                <a
                  href="https://api.whatsapp.com/send?phone=+6281211300567&text=Assalamu%27alaikum%2C%20saya%20ingin%20bertanya"
                  target="_blank"
                  title="WhatsApp"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-whatsapp"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"
                    />
                  </svg>
                </a>
                <a href="https://www.linkedin.com/company/masjed-id" target="_blank" title="WhatsApp">
                  <svg
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-whatsapp"
                    viewBox="0 0 512 512"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="m256 0c-141.363281 0-256 114.636719-256 256s114.636719 256 256 256 256-114.636719 256-256-114.636719-256-256-256zm-74.390625 387h-62.347656v-187.574219h62.347656zm-31.171875-213.1875h-.40625c-20.921875 0-34.453125-14.402344-34.453125-32.402344 0-18.40625 13.945313-32.410156 35.273437-32.410156 21.328126 0 34.453126 14.003906 34.859376 32.410156 0 18-13.53125 32.402344-35.273438 32.402344zm255.984375 213.1875h-62.339844v-100.347656c0-25.21875-9.027343-42.417969-31.585937-42.417969-17.222656 0-27.480469 11.601563-31.988282 22.800781-1.648437 4.007813-2.050781 9.609375-2.050781 15.214844v104.75h-62.34375s.816407-169.976562 0-187.574219h62.34375v26.558594c8.285157-12.78125 23.109375-30.960937 56.1875-30.960937 41.019531 0 71.777344 26.808593 71.777344 84.421874zm0 0"
                    />
                  </svg>
                </a>
              </div>
              <!-- <a href="#" class="inline-block mt-16 remove-gplaybutton">
                <img
                  :src="'/img/button_playstore.png'"
                  alt="Playstore"
                  class="remove-gplaybutton"
                />
              </a> -->
            </div>
          </div>
        </div>
      </div>
    </nav>
    <!-- <Layout> -->
    <div class="banner-page">
      <img :src="'/img/program-banner.jpg'" alt="Image" />
    </div>

    <div class="breadcrumbs">
      <div class="container">
        <ul>
          <li>
            <router-link :to="`/`">Beranda</router-link>
          </li>
          <li>
            <router-link :to="`/program`">Program</router-link>
          </li>
          <li class="capitalizeCrumb">
            <router-link :to="`/informasi-pembayaran-custom/${selfSlug}`">{{ titleCrumb }}</router-link>
          </li>
          <li>
            <span>Status Pembayaran</span>
          </li>
        </ul>
      </div>
    </div>

    <section class="page-section pembayaran">
      <div class="container">
        <div class="main-content bg-white">
          <div class="main-content bg-white pad-36">
            <form class="standar-form payment-after-action" action="javascript:void(0)">
              <!-- method label -->

              <h4>Status Pembayaran</h4>
              <div class="spacer"></div>

              <div class="nominal-label">
                <div class="loading-overlay" v-if="isLoading">
                  <div class="mohontunggu">
                    <p class="mohontunggu-text">Mohon menunggu,</p>
                    <p class="diproses-text">Sedang Diproses...</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="text">ID Transaksi</div>
                  </div>
                  <div class="col-md-12">
                    <div>
                      {{ statusData.no_transaksi || "" }}
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="text">Tanggal Transaksi</div>
                  </div>
                  <div class="col-md-12">
                    <div>{{ statusData.tgl_transaksi }}</div>
                  </div>

                  <!-- <div class="col-md-12">
                    <div class="text">Nama Donatur</div>
                  </div>
                  <div class="col-md-12">
                    <div>{{ statusData.namaDonatur }}</div>
                  </div> -->

                  <!-- <div class="col-md-12">
                    <div class="text">Email Donatur</div>
                  </div>
                  <div
                    class="col-md-12"
                    v-if="statusData.emailDonatur !== null"
                  >
                    <div>{{ statusData.emailDonatur }}</div>
                  </div> -->

                  <!-- <div class="col-md-12">
                    <div class="text">Telepon Donatur</div>
                  </div>
                  <div class="col-md-12">
                    <div>{{ statusData.telpDonatur }}</div>
                  </div> -->

                  <div class="col-md-12">
                    <div class="text">Nominal</div>
                  </div>
                  <div class="col-md-6">
                    <div>Rp. {{ statusData.amount | numeral("0,0") | rupiah }}</div>
                  </div>

                  <div class="col-md-12">
                    <div class="text">Status Pembayaran</div>
                  </div>
                  <div class="col-md-6">
                    <div class="number" :class="statusData.status === 'unverified' ? 'red' : 'green'">
                      {{ statusData.status }}
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="text">Metode Pembayaran</div>
                  </div>
                  <div class="col-md-6">
                    <div>{{ statusData.namaPembayaran }}</div>
                  </div>
                </div>
              </div>

              <div class="mt-3">
                <router-link to="/" class="btn btn-sm btn-cta btn-full">
                  Kembali Ke Beranda
                </router-link>
              </div>
            </form>

            <div class="spacer"></div>
            <div class="spacer"></div>
          </div>
        </div>
      </div>
    </section>
    <!-- </Layout> -->
    <slot />
    <footer>
      <div class="footer-top bg-main">
        <div class="container">
          <img src="/img/logoddtekno-white.svg" alt="Image" class="mb-16" style="height: 70px" />
          <div class="row">
            <div class="col-md-5">
              <div class="footer-title">PT Masjed Indonesia Digital</div>
              <table class="table-footer">
                <tbody>
                  <!-- <tr>
                    <td>
                      <img src="/img/house.svg" alt="Icon" />
                    </td>
                    <td> -->
                  <!-- Jakarta Selatan, Indonesia <br />
                      Jl. Warung Jati Barat No.14 <br />
                      Jakarta Selatan 12540, Indonesia -->
                  <!-- Jl. Sultan Iskandar Muda No 18I <br />
                      RT 001 / RW 002 <br />
                      Arteri Pondok Indah <br />
                      Kelurahan Kebayoran Lama Selatan, Kecamatan Kebayoran Lama
                      <br />
                      Jakarta Selatan - 12240 <br />
                      DKI Jakarta
                    </td>
                  </tr> -->
                  <tr>
                    <td><img :src="'/img/phone-call.svg'" alt="Icon" /></td>
                    <td>081211300567</td>
                  </tr>
                  <tr>
                    <td>
                      <img :src="'/img/gmail.svg'" alt="Icon" />
                    </td>
                    <td>marbot@masjed.id</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-7 d-none d-md-block mobile">
              <div class="row">
                <div class="col-md-4">
                  <div class="footer-title mobile">masjed.id</div>
                  <ul>
                    <li>
                      <a href="/tentang-kami">Tentang Kami</a>
                    </li>
                    <li>
                      <a href="/berita">Berita</a>
                    </li>
                    <li>
                      <a :href="link.program">Program</a>
                    </li>
                    <li>
                      <a href="/produk">Produk</a>
                    </li>
                  </ul>
                </div>
                <div class="col-md-4">
                  <div class="footer-title mobile">Bantuan</div>
                  <ul>
                    <li>
                      <a href="/syarat-dan-ketentuan">Syarat & Ketentuan</a>
                    </li>
                    <li>
                      <a href="/faq">F.A.Q</a>
                    </li>
                    <li>
                      <a href="/hubungi-kami">Hubungi Kami</a>
                    </li>
                  </ul>
                </div>
                <div class="col-md-4">
                  <div class="footer-title mobile">Ikuti Kami</div>
                  <div class="footer-sosmed">
                    <a href="https://www.facebook.com/appsmasjedid" class="facebook" target="_blank" title="Facebook">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-facebook"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"
                        />
                      </svg>
                    </a>
                    <a href="https://twitter.com/appsmasjedid" target="_blank" title="Twitter">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-twitter"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z"
                        />
                      </svg>
                    </a>
                    <a href="https://www.instagram.com/masjed.id/" target="_blank" title="Instagram">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-instagram"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"
                        />
                      </svg>
                    </a>
                    <a
                      href="https://api.whatsapp.com/send?phone=+6281211300567&text=Assalamu%27alaikum%2C%20saya%20ingin%20bertanya"
                      target="_blank"
                      title="WhatsApp"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-whatsapp"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"
                        />
                      </svg>
                    </a>
                    <a href="https://www.linkedin.com/company/masjed-id" target="_blank" title="WhatsApp">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 512 512"
                        fill="currentColor"
                        class="bi bi-whatsapp"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="m256 0c-141.363281 0-256 114.636719-256 256s114.636719 256 256 256 256-114.636719 256-256-114.636719-256-256-256zm-74.390625 387h-62.347656v-187.574219h62.347656zm-31.171875-213.1875h-.40625c-20.921875 0-34.453125-14.402344-34.453125-32.402344 0-18.40625 13.945313-32.410156 35.273437-32.410156 21.328126 0 34.453126 14.003906 34.859376 32.410156 0 18-13.53125 32.402344-35.273438 32.402344zm255.984375 213.1875h-62.339844v-100.347656c0-25.21875-9.027343-42.417969-31.585937-42.417969-17.222656 0-27.480469 11.601563-31.988282 22.800781-1.648437 4.007813-2.050781 9.609375-2.050781 15.214844v104.75h-62.34375s.816407-169.976562 0-187.574219h62.34375v26.558594c8.285157-12.78125 23.109375-30.960937 56.1875-30.960937 41.019531 0 71.777344 26.808593 71.777344 84.421874zm0 0"
                        />
                      </svg>
                    </a>
                  </div>
                  <!-- <a href="#" class="inline-block mt-16">
                    <img
                      :src="'/img/button_playstore.png'"
                      alt="Playstore"
                      id="img-playstore-footer"
                      class="img-playstore-footer"
                    />
                  </a> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="copyright">
        <div class="container">
          <p>
            ©COPYRIGHT PT Masjed Indonesia Digital ALL RIGHTS RESERVED.
          </p>
        </div>
      </div>
    </footer>
    <MenuFloat />
  </div>
</template>

<script>
import Layout from "../views/layouts/Index.vue";

import axios from "../utils/api";
import { mapState, mapActions } from "vuex";
import MenuFloat from "./layouts/Menu.vue";

export default {
  components: {
    Layout,
    MenuFloat,
  },
  name: "danai",
  data() {
    return {
      data: [],
      submitStatus: false,
      novirtual: "XXXXXX",
      dataPayment: "",
      statusData: "",
      isLoading: false,
      link: {
        program: "https://masjed.id/app/site/index",
        carimasjid: "https://masjed.id/app/site/index",
      },
      titleCrumb: "",
      selfSlug: "",
    };
  },
  mounted() {
    const { slug } = this.$router.history.current.params;

    window.scrollTo(0, 0);
    this.fetchDetail();
    window.history.forward(1);
    this.initialPaymentResponse();

    this.titleCrumb = slug.replace(/-/g, " ");
    this.selfSlug = slug;
  },
  created() {
    window.addEventListener("popstate", this.popstateEventAction);
    if (!this.isMobile()) {
      this.link = {
        program: "/program",
        carimasjid: "/cari-masjid",
      };
    }
  },
  computed: {
    ...mapState("transactions", [
      "programId",
      "paymentId",
      "paymentTitle",
      "paymentImage",
      "programTitle",
      "nominalDonasi",
      "userData",
      "paymentResponse",
    ]),
  },
  methods: {
    isMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },
    initialPaymentResponse() {
      const { data } = this.paymentResponse;
      this.dataPayment = data;
      this.novirtual = data.no_va || "XXXXX";
    },
    ...mapActions("transactions", ["setPaymentResponse"]),
    async fetchDetail() {
      const { slug } = this.$router.history.current.params;
      const detail = await axios.get(`/detailcampaign?slug=${slug}`);
      const { campaign } = detail.data.data;
      const { data } = this.paymentResponse;

      this.isLoading = true;
      const cekStatus = await axios.get(`/cektransaksi?no_transaksi=${data.trxid}`);
      this.isLoading = false;

      this.statusData = cekStatus.data.data;

      this.data = campaign;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "scss/payment-after-action";

.text {
  font-weight: bold;
  font-size: 12px !important;
}

.red {
  color: rgb(189, 27, 27);
}

.green {
  color: rgb(13, 172, 13);
}
.nominal-label {
  position: relative;
}
.loading-overlay {
  position: absolute;
  display: block;
  height: 100%;
  width: 100%;
  top: 0px;
  left: 0px;
  background: rgba($color: #000000, $alpha: 0.5);
}

.mohontunggu {
  color: #fff;
  text-align: center;
  position: relative;
  top: 40%;

  .mohontunggu-text {
    font-size: 11px;
    margin: 0px;
    padding: 0px;
    font-weight: bold;
  }

  .diproses-text {
    font-size: 15px;
    margin: 0px;
    padding: 0px;
    font-weight: bold;
  }
}
</style>
